import { BREAKPOINT_MAX_M } from '@/utils/mediaQuery';

export default defineNuxtPlugin({
  name: 'mobile-view',
  parallel: true,
  setup() {
    const mainStore = useMainStore();
    const updateMobileView = () => (mainStore.isMobileView = window.innerWidth <= BREAKPOINT_MAX_M);

    // Update initial state
    updateMobileView();

    // Required to keep value in sync when changing user agent in the devtools viewport emulator.
    // Doing manual comparisons since `window.matchMedia` didn't work reliably in the past.
    useWindowEventListener('resize', updateMobileView);
    updateMobileView();
  },
});
